/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation } from '@tanstack/react-query';
import { FormEvent, useState } from 'react';
import { Button, ErrorText, Field, Input } from '@/components/ui';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

/** Б-4: при входе со стандартным или слабым паролем программа предлагает его сменить; можно временно оставить. */
export function ForceChangePasswordPage() {
  const { me, reload, logout } = useAuth();
  const [pw, setPw] = useState({ current: '', next: '', repeat: '' });
  const later = useMutation({ mutationFn: () => api.post('/auth/password/postpone', {}), onSuccess: () => reload() });
  const change = useMutation({ mutationFn: () => api.post('/auth/password', { current: pw.current, next: pw.next }), onSuccess: () => logout() });
  const submit = (e: FormEvent) => { e.preventDefault(); if (pw.next === pw.repeat) change.mutate(); };
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <form onSubmit={submit} className="card w-full max-w-sm space-y-3 p-6">
        <div className="text-lg font-semibold">Слабый пароль</div>
        <p className="text-sm text-slate-600">{me?.fullName}, вы вошли с паролем первого входа или слишком простым паролем. Его легко подобрать. Рекомендуем задать новый; можно оставить пока, тогда напоминание появится при следующем входе.</p>
        <Field label="Текущий пароль"><Input type="password" value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} autoFocus /></Field>
        <Field label="Новый пароль" hint="Не короче 10 символов, буквы и цифры"><Input type="password" value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} /></Field>
        <Field label="Повторите новый пароль"><Input type="password" value={pw.repeat} onChange={(e) => setPw({ ...pw, repeat: e.target.value })} /></Field>
        {pw.repeat && pw.next !== pw.repeat && <div className="text-sm text-red-600">Пароли не совпадают</div>}
        <ErrorText error={change.error} />
        <div className="flex gap-2"><Button type="submit" disabled={change.isPending || !pw.next || pw.next !== pw.repeat}>Сменить пароль</Button><Button type="button" variant="secondary" disabled={later.isPending} onClick={() => later.mutate()}>Оставить пока</Button></div>
        <ErrorText error={later.error} />
      </form>
    </div>
  );
}
